import { render } from "./ListCaracteristicaSobreNos.vue?vue&type=template&id=de577eaa&scoped=true"
import script from "./ListCaracteristicaSobreNos.vue?vue&type=script&lang=js"
export * from "./ListCaracteristicaSobreNos.vue?vue&type=script&lang=js"

import "./ListCaracteristicaSobreNos.vue?vue&type=style&index=0&id=de577eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de577eaa"]])

export default __exports__